import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';

export const GET_BUSINESS_APPOINTMENTS_TYPE = 'businessAppointments/get_business_appointments_type' as const;

export type TGetBusinessAppointments = IReduxAction<typeof GET_BUSINESS_APPOINTMENTS_TYPE>;

export const getBusinessAppointmentsAction =
  actionGenerator<typeof GET_BUSINESS_APPOINTMENTS_TYPE>(GET_BUSINESS_APPOINTMENTS_TYPE);
